import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _9kPlusIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"9k_plus"} ref={ref}/>
});

_9kPlusIcon.displayName = "_9kPlusIcon";
